import * as Rx from 'rxjs';
import RxOp from 'rxjs-operators';

import apiService, { ApiService } from './api';

export class TicketService {
  constructor(private apiService: ApiService) {
    this.apiService = apiService;
  }

  public delete(id: string): Rx.Observable<void> {
    return this.apiService.delete(`/ticket/delete/${id}`);
  }

  public print(eventId: string, inviteKey?: string): Rx.Observable<any> {
    return this.apiService
      .get(`/ticket/print/${eventId}${inviteKey ? '/' + inviteKey : ''}`)
      .pipe(RxOp.map(response => response.data));
  }

  public printPublic(eventId: string, attendanceId: string): Rx.Observable<any> {
    return this.apiService
      .get(`/ticket/public/print/${eventId}/${attendanceId}`)
      .pipe(RxOp.map(response => response.data));
  }
  public attendancePrinted(eventId: string, attendanceIds: string[]) {
    return this.apiService.put('/attendance_list/attendance_printed', { eventId, attendanceIds });
  }

  public publicAttendancePrinted(transactionKey: string, email: string, attendanceIds: string[]) {
    return this.apiService.put('/public/attendance_printed', { transactionKey, email, attendanceIds });
  }
}

const ticketService = new TicketService(apiService);
export default ticketService;
